<script>
import ModalSimulatorOfficialComponent from '../../features/modals/ModalSimulatorOfficialComponent';
import ModalSimulatorOfficialSectionView from './ModalSimulatorOfficialSectionView';
import draggable from 'vuedraggable';

export default {
  name: 'ModalSimulatorOfficialOfficialView',
  components: {
    'modal-simulator-official-section-view': ModalSimulatorOfficialSectionView,
    draggable,
  },
  extends: ModalSimulatorOfficialComponent,
};
</script>

<template>
  <div>
    <el-dialog
      v-model="conf.isVisible"
      title="Simulador"
      width="50%"
      class="simulator-modal"
      append-to-body
      :before-close="onCancel"
      :close-on-click-modal="false"
    >
      <el-form
        ref="formData"
        v-loading="conf.isLoading"
        :model="formData"
        :rules="rules"
        status-icon
        :label-position="'top'"
      >
        <fieldset>
          <legend>Información de Simulador</legend>

          <!-- Cover Image Section -->
          <div class="simulator-cover-wrapper">
            <div class="simulator-cover-preview">
              <img
                :src="coverImageUrl"
                alt="Imagen de portada"
              >
            </div>
            <div class="simulator-cover-content">
              <div>
                <h4 class="cover-title">
                  <i class="uil uil-image-upload" />
                  Imagen de Portada
                </h4>
                <p class="cover-desc">
                  Sube la imagen representativa del simulador. Asegúrate de cumplir con los estándares técnicos para garantizar una visualización óptima en la plataforma.
                </p>
                <div class="cover-specs">
                  <span class="spec-tag">
                    <i class="uil uil-expand-arrows-alt" />
                    <strong>750 × 422 px</strong> (16:9)
                  </span>
                  <span class="spec-tag">
                    <i class="uil uil-file-alt" />
                    <strong>JPG, PNG o GIF</strong>
                  </span>
                  <span class="spec-tag">
                    <i class="uil uil-shield-check" />
                    <strong>Sin texto superpuesto</strong>
                  </span>
                </div>
              </div>
              <div class="cover-actions">
                <el-upload
                  v-if="!isCoverImageTemp && !formData.coverImageUrl"
                  class="cover-uploader"
                  :name="'coverImageFileUploader'"
                  action
                  :on-success="onSuccessUploadCoverImage"
                  :before-upload="onBeforeUploadCoverImage"
                  :show-file-list="false"
                  :data="coverImageFile"
                >
                  <el-button
                    size="small"
                    type="primary"
                    class="btn-primary"
                    icon="el-icon-upload2"
                  >
                    Subir Imagen
                  </el-button>
                </el-upload>
                <template v-else>
                  <el-upload
                    class="cover-uploader"
                    :name="'coverImageFileUploader'"
                    action
                    :on-success="onSuccessUploadCoverImage"
                    :before-upload="onBeforeUploadCoverImage"
                    :show-file-list="false"
                    :data="coverImageFile"
                  >
                    <el-button
                      size="small"
                      class="btn-primary-light"
                      icon="el-icon-refresh"
                    >
                      Cambiar Imagen
                    </el-button>
                  </el-upload>
                  <el-button
                    size="small"
                    type="danger"
                    plain
                    class="btn-delete-cover"
                    icon="el-icon-delete"
                    @click="onRemoveCoverImage"
                  >
                    Eliminar
                  </el-button>
                </template>
              </div>
            </div>
          </div>

          <el-row
            type="flex"
            class="row-bg"
            :gutter="20"
          >
            <el-col
              :xs="24"
              :sm="24"
              :md="24"
              :lg="24"
              :xl="24"
            >
              <el-form-item
                label="Nombre"
                prop="name"
              >
                <el-input
                  v-model="formData.name"
                  placeholder="Nombre"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            class="row-bg"
            :gutter="20"
          >
            <el-col :span="24">
              <el-form-item
                label="Descripción"
                prop="description"
              >
                <el-input
                  v-model="formData.description"
                  type="textarea"
                  :row="3"
                  maxlength="255"
                  size="small"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            class="row-bg"
            :gutter="20"
          >
            <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12"
            >
              <el-form-item
                label="Universidad"
                prop="university"
              >
                <el-select
                  v-model="formData.university"
                  placeholder="Seleccionar"
                  value-key="id"
                  clearable
                  filterable
                  @change="onChangeUniversity"
                >
                  <el-option
                    v-for="item in universities"
                    :key="item.id"
                    :label="item.name"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12"
            >
              <el-form-item
                label="Carrera"
                prop="career"
              >
                <el-select
                  v-model="formData.career"
                  placeholder="Seleccionar"
                  value-key="id"
                  clearable
                  filterable
                  :disabled="!formData.university"
                >
                  <el-option
                    v-for="item in careers"
                    :key="item.id"
                    :label="item.name"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            class="row-bg"
            :gutter="20"
          >
            <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="6"
              :xl="6"
              align="center"
            >
              <el-form-item label="¿Publicado?">
                <el-switch
                  v-model="formData.isPublic"
                  active-color="#13ce66"
                  active-text="SI"
                  inactive-text="NO"
                />
              </el-form-item>
            </el-col>
            <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="6"
              :xl="6"
              align="center"
            >
              <el-form-item label="¿Es Temporizado?">
                <el-switch
                  v-model="formData.isTimer"
                  active-color="#13ce66"
                  active-text="SI"
                  inactive-text="NO"
                  @change="isTimerChange"
                />
              </el-form-item>
            </el-col>
            <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="6"
              :xl="6"
              align="center"
            >
              <el-form-item
                label="Tipo de Temporizado"
                prop="timerType"
              >
                <el-select
                  v-model="formData.timerType"
                  clearable
                  filterable
                  placeholder="Seleccionar"
                  value-key="id"
                  size="small"
                  :disabled="!formData.isTimer"
                  @change="isTimerTypeChange"
                >
                  <el-option
                    v-for="item in timerTypes"
                    :key="item.id"
                    :label="item.name"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="6"
              :xl="6"
              align="center"
            >
              <el-form-item
                label="Duración Total(Min.)"
                prop="duration"
              >
                <el-input-number
                  v-model="formData.duration"
                  size="small"
                  :disabled="!onAllowDuration()"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            class="row-bg"
            :gutter="20"
          >
            <el-col
              :xs="24"
              :sm="24"
              :md="8"
              :lg="8"
              :xl="8"
              align="center"
            >
              <el-form-item
                label="Numero de Preguntas"
                prop="questionQuantity"
              >
                <el-input-number
                  v-model="formData.questionQuantity"
                  size="small"
                />
              </el-form-item>
            </el-col>
            <el-col
              :xs="24"
              :sm="24"
              :md="8"
              :lg="8"
              :xl="8"
              align="center"
            >
              <el-form-item
                label="Puntaje Minimo"
                prop="minimumScore"
              >
                <el-input-number
                  v-model="formData.minimumScore"
                  size="small"
                />
              </el-form-item>
            </el-col>
            <el-col
              :xs="24"
              :sm="24"
              :md="8"
              :lg="8"
              :xl="8"
              align="center"
            >
              <el-form-item
                label="Puntaje Maximo"
                prop="topScore"
              >
                <el-input-number
                  v-model="formData.topScore"
                  size="small"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- Simulator Sections Section -->
          <div class="simulator-section-header">
            <div class="title-icon">
              <h3 class="title">
                <i class="uil uil-layers" /> Secciones del Simulador
              </h3>
            </div>
            <el-button
              type="primary"
              size="small"
              class="btn-primary"
              icon="el-icon-circle-plus"
              :disabled="!onCanCreateSimulatorSection()"
              @click="onAddSection()"
            >
              Agregar Sección
            </el-button>
          </div>

          <el-alert
            v-if="!formData.university || !formData.career || !formData.questionQuantity"
            title="Para agregar secciones, debes seleccionar Universidad, Carrera e indicar el Número de Preguntas."
            type="warning"
            show-icon
            :closable="false"
            class="simulator-section-alert"
          />

          <div class="simulator-sections-wrapper">
            <!-- Empty State -->
            <div
              v-if="!hasVisibleSimulatorSections()"
              class="simulator-sections-empty"
            >
              <el-empty
                :image-size="70"
                description="No hay secciones agregadas en este simulador todavía."
              >
                <el-button
                  type="primary"
                  size="small"
                  class="btn-primary"
                  icon="el-icon-circle-plus"
                  :disabled="!onCanCreateSimulatorSection()"
                  @click="onAddSection()"
                >
                  Agregar Primera Sección
                </el-button>
              </el-empty>
            </div>

            <!-- Sections Table -->
            <div
              v-else
              class="simulator-sections-table"
            >
              <div class="sections-table-head">
                <div class="th-col col-sort">ORDEN</div>
                <div class="th-col col-title">SECCIÓN</div>
                <div class="th-col col-questions">NO. PREGUNTAS</div>
                <div class="th-col col-actions">OPCIONES</div>
              </div>

              <draggable
                v-model="formData.simulatorSections"
                item-key="sort"
                handle=".drag-handle"
                ghost-class="ghost-section-row"
                @change="onChangeDrag(formData.simulatorSections)"
              >
                <template #item="{ element, index }">
                  <div
                    v-show="element.updateState !== formData.UPDATE_STATUS.REMOVED"
                    :key="element.sort || index"
                    class="sections-table-row"
                  >
                    <!-- Drag / Order -->
                    <div class="td-col col-sort">
                      <i
                        class="fa fa-grip-vertical drag-handle"
                        title="Arrastrar para ordenar"
                      />
                      <span class="order-badge">{{ element.sort }}</span>
                    </div>

                    <!-- Sección -->
                    <div class="td-col col-title">
                      <span class="section-title-text" v-html="element.name" />
                      <span
                        v-if="element.description"
                        class="section-desc-text"
                      >{{ element.description }}</span>
                    </div>

                    <!-- No. Preguntas -->
                    <div class="td-col col-questions">
                      <el-tag
                        size="small"
                        type="primary"
                        effect="plain"
                      >
                        <i class="fa fa-question-circle" />
                        {{ element.questionQuantity }} preguntas
                      </el-tag>
                    </div>

                    <!-- Opciones -->
                    <div class="td-col col-actions">
                      <el-dropdown
                        trigger="click"
                        @command="onChangeItemOptions"
                      >
                        <el-button
                          size="small"
                          class="btn-row-action"
                        >
                          <i class="fa fa-ellipsis-v" />
                        </el-button>
                        <template #dropdown>
                          <el-dropdown-menu>
                            <el-dropdown-item
                              :command="{
                                command: 'edit',
                                item: element,
                                index: index,
                              }"
                              :disabled="!onCanReadSimulatorOfficial(modulePermissions)"
                            >
                              <i class="el-icon-edit" />
                              Mostrar
                            </el-dropdown-item>
                            <el-dropdown-item
                              :command="{
                                command: 'delete',
                                item: element,
                                index: index,
                              }"
                              :disabled="!onCanDeleteSimulatorOfficial(modulePermissions)"
                              divided
                            >
                              <i class="el-icon-delete" />
                              Eliminar
                            </el-dropdown-item>
                          </el-dropdown-menu>
                        </template>
                      </el-dropdown>
                    </div>
                  </div>
                </template>
              </draggable>
            </div>
          </div>
        </fieldset>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            size="small"
            class="btn-cancel"
            @click="onCancel"
          >Cancelar</el-button>
          <el-button
            type="primary"
            :disabled="!onCanSaveOrUpdate()"
            class="btn-primary"
            size="small"
            @click="onSubmitForm('formData')"
          >Guardar</el-button>
        </span>
      </template>
    </el-dialog>
    <modal-simulator-official-section-view
      v-if="modalItemSection.isVisible"
      :form-data="itemSection"
      :conf="modalItemSection"
    />
  </div>
</template>
